export default "__VITE_ASSET__CVOKo_FD__"